import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _createForOfIteratorHelper from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import env from '../env';
import util from '../util';
import config from './config';
var callbacks = [];
var loadScript = false;
var isInQnReadingApp = navigator.userAgent.indexOf('qnreading') >= 0;

function readyCallback() {
  window.TencentNews = window.TencentNews || window.TencentReading;

  var _iterator = _createForOfIteratorHelper(callbacks),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var func = _step.value;
      func();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  callbacks = [];
}

function newsApiReady(func) {
  if (window.TencentNews || window.TencentReading) {
    window.TencentNews = window.TencentNews || window.TencentReading;
    func();
  } else {
    if (env.isAndroid && !loadScript) {
      util.loadScript('news_script', env.isAndroid && isInQnReadingApp ? '//mat1.gtimg.com/www/reading/android/js/jsapi/jsapi.js' : '//mat1.gtimg.com/www/js/newsapp/jsapi/news.js?_tsid=1', function () {
        readyCallback();
      });
      loadScript = true;
    } else if (env.isIos || env.isIpad) {
      if (!window._TencentNewsReady_) {
        window._TencentNewsReady_ = readyCallback;
      }
    }

    callbacks.push(func);
  }
}

function checkCanOpenVideoApp() {
  return new Promise(function (resolve) {
    newsApiReady(function () {
      if (env.isIos) {
        TencentNews.checkCanOpenNativeUrl('tenvideo2://', function (url, result) {
          resolve(result);
        });
      } else if (env.isAndroid) {
        var packageName = 'com.tencent.qqlive';

        window['checkCanOpenNativeUrlCallBack'] = function (result) {
          resolve(result);
        };

        if (isInQnReadingApp) {
          TencentNews.checkCanOpenNativeUrl(packageName, 'checkCanOpenNativeUrlCallBack', null);
        } else {
          TencentNews.checkCanOpenNativeUrl(packageName, 'checkCanOpenNativeUrlCallBack');
        }
      }
    });
  });
}

export var canGetInstallState = true;
export function ready() {
  return new Promise(function (resolve) {
    newsApiReady(resolve);
  });
}
export function getInstallState() {
  return _getInstallState.apply(this, arguments);
}

function _getInstallState() {
  _getInstallState = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", checkCanOpenVideoApp());

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getInstallState.apply(this, arguments);
}

export function launch(_x) {
  return _launch.apply(this, arguments);
}

function _launch() {
  _launch = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(schemeUrl) {
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (env.isIos) {
              TencentNews.openNativeUrl(schemeUrl, function () {}, null);
            } else if (env.isAndroid) {
              TencentNews.openApp(schemeUrl, 'com.tencent.qqlive');
            }

            return _context2.abrupt("return", true);

          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _launch.apply(this, arguments);
}

export function download() {
  return _download.apply(this, arguments);
}

function _download() {
  _download = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (env.isIos) {
              TencentNews.openNativeUrl(config.download, function () {}, null);
            } else if (env.isAndroid) {
              TencentNews.downloadApp(config.download, 'com.tencent.qqlive', '腾讯视频');
              TencentNews.showTextTips('开始下载腾讯视频APP！');
            }

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _download.apply(this, arguments);
}

export default {
  canGetInstallState: canGetInstallState,
  ready: ready,
  getInstallState: getInstallState,
  launch: launch,
  download: download
};